export const CHANGE_LABEL_TYPE = 'CHANGE_LABEL_TYPE';
export const CHANGE_FIELD = 'CHANGE_FIELD';
export const PREPARE_LABEL_TO_PRINT = 'PREPARE_LABEL_TO_PRINT';
export const TOGGLE_ALTERNATE_PRINT_FORMAT = 'TOGGLE_ALTERNATE_PRINT_FORMAT';
export const TOGGLE_FIELD = 'TOGGLE_FIELD';
